<template>
    <div>
        <Modal v-model="modal" :title="!complianceChecksWarningForm.id ? this.$t('alarms.complianceChecks.addComplianceChecks'):this.$t('alarms.complianceChecks.updateComplianceChecks')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :closable="false">
            <Form ref="complianceChecksWarningForm" :model="complianceChecksWarningForm" :label-width="110" :rules="ruleValidate">
                <!-- 微信警告 -->
                <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
                <!-- 规则名称 -->
                <FormItem :label="this.$t('alarms.common.alertRuleName')" prop="ruleName" v-if="isEditRuleName">
                    <Row>
                        <Col span="11">
                            <Input type="text" v-model="complianceChecksWarningForm.ruleName" placeholder="Enter something..."
                           style="width:300px;" :disabled="isEdit"></Input>
                        </Col>
                     </Row>
                </FormItem>

                <!-- 规则名称 -->
                <FormItem :label="this.$t('alarms.common.alertRuleName')" v-if="showRuleName">
                    <Row>
                        <Col span="24">
                            <div>{{this.complianceChecksWarningForm.ruleName}}</div>
                        </Col>
                    </Row>
                </FormItem>


                <!-- 账户 -->
                <FormItem :label="this.$t('alarms.common.account')" prop="account">
                    <Select v-model="complianceChecksWarningForm.account" :placeholder="this.$t('alarms.common.pleaseSelect')" @on-change="changeAccount(complianceChecksWarningForm.account)" :transfer="true" style="width:300px;">
                        <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 存储区域 -->
                <FormItem :label="this.$t('alarms.common.region')" prop="backupRegion">
                    <Select @on-change="changebackupRegion(complianceChecksWarningForm.backupRegion)" :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="complianceChecksWarningForm.backupRegion" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                        <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                        <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 合规检查 -->
                <FormItem :label="this.$t('alarms.complianceChecks.compliance')" prop="configRuleNames">
                    <Select @on-change="changeConfigRuleNames(complianceChecksWarningForm.configRuleNames)" :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="complianceChecksWarningForm.configRuleNames" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                        <Checkbox v-model="singleConfigRuleNames" @on-change="selectConfigRuleNamesAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                        <Option :value="item.configRuleName" v-for="(item,index) in configRuleNamesList" :key="index">{{item.configRuleName}}</Option>
                    </Select>
                </FormItem>

                <!-- 规则描述 -->
                <FormItem :label="this.$t('alarms.common.alertRuleDesc')">
                    <Row :gutter="4">
                        <!-- 监控指标 -->
                        <Col span="6">
                            <FormItem prop="monitorIndex">
                                <Select v-model="complianceChecksWarningForm.monitorIndex" @on-change="changeMonitorIndex(complianceChecksWarningForm.monitorIndex)" :placeholder="this.$t('alarms.common.monitorIndex')">
                                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 周期 -->
                        <Col span="3">
                            <FormItem prop="cycle">
                                <Select v-model="complianceChecksWarningForm.cycle" @on-change="changeCycle(complianceChecksWarningForm.cycle)" :placeholder="this.$t('alarms.common.cycle')">
                                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 连续周期 -->
                        <Col span="4">
                            <FormItem prop="continousCycle">
                                <Select v-model="complianceChecksWarningForm.continousCycle" :placeholder="this.$t('alarms.common.continuous')"
                                      @on-change="changeContinousCycle(complianceChecksWarningForm.continousCycle)">
                                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 统计数值 -->
                        <Col span="4">
                            <FormItem prop="statisticsValue">
                                <Select v-model="complianceChecksWarningForm.statisticsValue" :placeholder="this.$t('alarms.common.statisticsValue')"
                                  @on-change="changeStatisticsValue(complianceChecksWarningForm.statisticsValue)">
                                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>


                        <!-- 如果监控指标为合规性检查项时 不显示符号、阈值和单位 -->
                        <div v-if="this.isShowField!=1">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="complianceChecksWarningForm.relationshipSign" @on-change="changeRelationshipSign(complianceChecksWarningForm.relationshipSign)" :placeholder="this.$t('alarms.common.sign')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="complianceChecksWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')"
                                       type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="complianceChecksWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                        <div v-else-if="this.isShowField==2">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="complianceChecksWarningForm.relationshipSign"  @on-change="changeRelationshipSign(complianceChecksWarningForm.relationshipSign)" :placeholder="this.$t('alarms.common.sign')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="complianceChecksWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')" type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="complianceChecksWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                    </Row>
                </FormItem>

                <!-- 联系方式 -->
                <FormItem :label="this.$t('alarms.billing.contactWay')" prop="contactType">
                    <RadioGroup v-model="complianceChecksWarningForm.contactType" @on-change="changeContactType(complianceChecksWarningForm.contactType)">
                        <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 通知对象 -->
                <FormItem :label="this.$t('alarms.common.contact')" prop="notificationObject"  v-if="complianceChecksWarningForm.contactType==0">
                    <Select v-model="complianceChecksWarningForm.notificationObject" multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 联系人组 -->
                <FormItem :label="this.$t('alarms.common.alertContactGroup')" prop="contactGroupIds" v-if="complianceChecksWarningForm.contactType==1">
                    <Select v-model="complianceChecksWarningForm.contactGroupIds" multiple style="width:300px;" @on-change="changeContactGroupId(complianceChecksWarningForm.contactGroupIds)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 报警方式 -->
                <FormItem :label="this.$t('alarms.common.alarmType')" prop="noticeType">
                    <Select v-model="complianceChecksWarningForm.noticeType" multiple style="width:300px;" @on-change="selectnoticeType(complianceChecksWarningForm.noticeType)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 企业微信机器人URL -->
                <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="complianceChecksWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
                    <Select v-model="complianceChecksWarningForm.enterpriseWechatRobotIds" multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 延迟告警 -->
                <FormItem :label="this.$t('alarms.common.delayAlarm')" prop="alarmDelay">
                    <Select v-model="complianceChecksWarningForm.alarmDelay" style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

              <!-- 监控时段 -->
              <FormItem :label="this.$t('alarms.common.monitoringTime')" prop="monitorPeriod">
                <Select v-model="complianceChecksWarningForm.monitorPeriod" style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                  <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>

                <!-- 邮箱模板 -->
                <div v-show="isShowEmail">
                    <FormItem :label="this.$t('alarms.common.emailTemplate')" prop="emailModal">
                        <Input v-model="complianceChecksWarningForm.emailModal" type="textarea"
                         :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>

                <!-- 企业微信模板 -->
                <div v-show="isShowWeChat">
                    <FormItem :label="this.$t('alarms.common.weChatTemplate')" prop="wechatModal">
                        <Input v-model="complianceChecksWarningForm.wechatModal" type="textarea"
                         :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>
            </Form>
            <div slot="footer">
                <Button size="large" @click="cancel('complianceChecksWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
                <Button type="primary" size="large" @click="ok('complianceChecksWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
                  {{!complianceChecksWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import WechatWarning from '../../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
    import TableComplianceChecksWarning from '../complianceChecks_monitor/TableComplianceChecksWarning.vue'

    var tableComplianceChecksWarning = TableComplianceChecksWarning;
    var tableComplianceChecksWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.complianceChecksWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error('规则名称不能重复!'));
                    }
                })
            };
            return {
                monitorModule:33,
                addloading:false,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                  label: this.$t('alarms.common.alertContact'),
                    value: 'contact',
                    type: 0
                },
                {
                  label: this.$t('alarms.common.alertContactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                isShowField: '', //是否显示符号、阈值和单位
                singleBackupRegion:false,
                singleConfigRuleNames:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit: false,
                isEditRuleName: false,
                showRuleName: false,
                isShowEmail: false,
                isShowWeChat: false,
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                configRuleNamesList:[],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                unit: '',
                complianceChecksWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    configRuleNames:[],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds: [],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: '请选择账户名称', trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: '请选择延迟告警', trigger: 'change', type: 'number'}
                    ],
                    monitorPeriod: [
                        {required: true, message: '请选择监控时段', trigger: 'change', type: 'number'}
                    ],
                    backupRegion: [
                        {required: true, type: 'array', message: '请选择存储区域', trigger: 'change'}
                    ],
                    configRuleNames: [
                        {required: true, type: 'array', message: '请选择合规检查', trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: '规则名称不能为空', trigger: 'blur'},
                        {type: 'string', message: '规则名称为2-20个字符首尾中间不能有空格', pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: '请选择通知对象', trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: '请选择监控指标', trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: '请选择周期', trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: '请选择连续周期', trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: '请选择统计数值', trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: '请选择关系符号', trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: '请输入阈值'}
                    ],
                    contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: '请选择企业微信机器人URL', trigger: 'change'}
                    ]
                }
            }
        },

        beforeCreate: function () {
            tableComplianceChecksWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            init: function (id) {
                this.complianceChecksWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableComplianceChecksWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['complianceChecksWarningForm'].resetFields();
                    // 编辑
                    if (this.complianceChecksWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.$api.alertRule.selectAlertRule("id", this.complianceChecksWarningForm.id)
                            .then(res => {
                                //延时
                                this.complianceChecksWarningForm.alarmDelay = res.data.delay;
                                //监控时段
                                this.complianceChecksWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.complianceChecksWarningForm.account = res.data.accountId;
                                // 存储区域
                                tableComplianceChecksWarningVue.$api.account.queryAccountRegions("accountId", this.complianceChecksWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });
                               // 联系人
                              tableComplianceChecksWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                "monitorModule":this.monitorModule,
                                "accountId":this.complianceChecksWarningForm.account
                              })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                setTimeout(() => {
                                    this.complianceChecksWarningForm.backupRegion = res.data.regions;
                                }, 1000)

                                // 规则名称
                                this.complianceChecksWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                // 查询监控指标
                                tableComplianceChecksWarningVue.$api.alertRule.searchMonitorIndex({
                                    "monitorModule":this.monitorModule,
                                    "accountId":this.complianceChecksWarningForm.account
                                })
                                .then(res => {
                                    this.monitorIndexList = res.data;
                                })
                                this.complianceChecksWarningForm.monitorIndex = res.data.monitorIndex;
                                // 如果监控指标为合规性检查项时 不显示符号、阈值和单位
                                if (this.complianceChecksWarningForm.monitorIndex == 58) {
                                    this.isShowField = 1;
                                } else {
                                    this.isShowField = 2;
                                }

                                // 周期
                                this.complianceChecksWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.complianceChecksWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.complianceChecksWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.complianceChecksWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.complianceChecksWarningForm.thresholdValue = res.data.thresholdValue;
                                // 单位
                                this.complianceChecksWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;

                                // 合规检查
                                this.complianceChecksWarningForm.configRuleNames=res.data.configRuleNames;
                                // 企业微信机器人URL
                                this.complianceChecksWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.complianceChecksWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.complianceChecksWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.complianceChecksWarningForm.notificationObject.length;i++){
                                        for(var j=0;j<this.notificationObjectList.length;j++){
                                            if(this.complianceChecksWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                                this.complianceChecksWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                            }
                                        }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.complianceChecksWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.complianceChecksWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }

                                // 查询阈值
                                tableComplianceChecksWarningVue.selectMonitorIndexDefault();

                                // 报警方式
                                this.complianceChecksWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.complianceChecksWarningForm.noticeType.length; i++){
                                    if (this.complianceChecksWarningForm.noticeType[i] == '0') {
                                        this.isShowEmail = true;
                                        this.complianceChecksWarningForm.emailModal = res.data.briefReportBodyMail;
                                        this.noticeType = this.complianceChecksWarningForm.noticeType;
                                        tableComplianceChecksWarningVue.selectTemplate();
                                    }
                                    if (this.complianceChecksWarningForm.noticeType[i] == '1') {
                                        // this.isShowWeChat = true;
                                        this.complianceChecksWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                        this.checkLeastOnePersonBoundWeChat();
                                        this.noticeType = this.complianceChecksWarningForm.noticeType;
                                        tableComplianceChecksWarningVue.selectTemplate();
                                    }else if(this.complianceChecksWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }
                                }
                            })
                    } else {
                        this.isEdit = false;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.complianceChecksWarningForm.cycle = '';
                this.complianceChecksWarningForm.continousCycle = '';
                this.complianceChecksWarningForm.statisticsValue = '';
                this.complianceChecksWarningForm.relationshipSign = '';
                this.complianceChecksWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                // 如果监控指标为合规性检查项时 不显示符号、阈值和单位
                if (this.complianceChecksWarningForm.monitorIndex == 58) {
                    this.isShowField = 1;
                } else {
                    this.isShowField = 2;
                }
                tableComplianceChecksWarningVue.selectMonitorIndexDefault();
                this.unit = this.complianceChecksWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.complianceChecksWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableComplianceChecksWarningVue.selectTemplate();
                tableComplianceChecksWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                tableComplianceChecksWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.complianceChecksWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.complianceChecksWarningForm.cycle,
                    "continousCycle": this.complianceChecksWarningForm.continousCycle,
                    "statisticsValue": this.complianceChecksWarningForm.statisticsValue,
                    "relationshipSign": this.complianceChecksWarningForm.relationshipSign
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableComplianceChecksWarningVue.isNotEmpty(this.complianceChecksWarningForm.cycle) && tableComplianceChecksWarningVue.isNotEmpty(this.complianceChecksWarningForm.continousCycle) && tableComplianceChecksWarningVue.isNotEmpty(this.complianceChecksWarningForm.statisticsValue) && tableComplianceChecksWarningVue.isNotEmpty(this.complianceChecksWarningForm.relationshipSign) && this.complianceChecksWarningForm.id == 0) {
                        this.complianceChecksWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableComplianceChecksWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.complianceChecksWarningForm.monitorIndex,
                    "relationshipSign": this.complianceChecksWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.complianceChecksWarningForm.noticeType
                })
                .then(res => {
                    this.complianceChecksWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.complianceChecksWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
                this.isShowEmail = false;
                this.isShowWeChat = false;
                for(var i=0;i<this.complianceChecksWarningForm.noticeType.length;i++) {
                    if (this.complianceChecksWarningForm.noticeType[i] == '0') {
                        this.isShowEmail = true;
                        this.noticeType = this.complianceChecksWarningForm.noticeType;
                        tableComplianceChecksWarningVue.selectTemplate();
                    }
                    if (this.complianceChecksWarningForm.noticeType[i] == '1') {
                        // this.isShowWeChat = true;
                        this.noticeType = this.complianceChecksWarningForm.noticeType;
                        this.checkLeastOnePersonBoundWeChat();
                        tableComplianceChecksWarningVue.selectTemplate();
                    }else if(this.complianceChecksWarningForm.noticeType[i]!='1'){
                        this.wechatWarningVisible=false;
                        this.isAddOrEdit=false;
                    }
                }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.complianceChecksWarningForm.noticeType.length;i++){
                  if(this.complianceChecksWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.complianceChecksWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.complianceChecksWarningForm.contactType==0){
                          weChatDate.userIds=this.complianceChecksWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.complianceChecksWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.complianceChecksWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.complianceChecksWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.complianceChecksWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.complianceChecksWarningForm.userIdList=[];
              this.complianceChecksWarningForm.notificationObject=val;
              for(var i=0;i<this.complianceChecksWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.complianceChecksWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.complianceChecksWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableComplianceChecksWarningVue.$api.alertRule.searchMonitorIndex({
                    "monitorModule":this.monitorModule,
                    "accountId":this.complianceChecksWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableComplianceChecksWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.complianceChecksWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.complianceChecksWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询合规检查
            queryConfigRuleCheckItems: function () {
                tableComplianceChecksWarningVue.$api.awsConfigCheckItem.queryConfigRuleCheckItems({})
                .then(res => {
                    this.configRuleNamesList = res.data;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableComplianceChecksWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                    this.alarmWayList = res.data;
                })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableComplianceChecksWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                    this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableComplianceChecksWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableComplianceChecksWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableComplianceChecksWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableComplianceChecksWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableComplianceChecksWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                tableComplianceChecksWarningVue.$api.account.queryAWSAccounts()
                .then(res => {
                    this.accountList = res.data;
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                    }
                })
                // 查询阈值
                tableComplianceChecksWarningVue.selectMonitorIndexDefault();
                // 查询方式
                tableComplianceChecksWarningVue.alarmWay();
                // 查询报警延时
                tableComplianceChecksWarningVue.getAlarmDelay();
                //监控时段
                tableComplianceChecksWarningVue.searchMonitorPeriod();
                // 查询合规检查
                tableComplianceChecksWarningVue.queryConfigRuleCheckItems();
                // 监控模块查询关联的机器人列表
                tableComplianceChecksWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableComplianceChecksWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                    this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
            changeAccount: function () {
                if (this.complianceChecksWarningForm.account == "" || this.complianceChecksWarningForm.account == null) {
                    return;
                }
                this.complianceChecksWarningForm.backupRegion = [];
                // 查询监控指标
                tableComplianceChecksWarningVue.searchMonitorIndex();
                // 清空表格
                tableComplianceChecksWarningVue.$api.account.queryAccountRegions("accountId", this.complianceChecksWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
               // 查询通知对象
               tableComplianceChecksWarningVue.queryContacts();
              // 查询联系人组
              tableComplianceChecksWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.complianceChecksWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.complianceChecksWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.complianceChecksWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
            },
            /***********合规检查**************************/
            selectConfigRuleNamesAll(){
                this.complianceChecksWarningForm.configRuleNames = []
                if (this.singleConfigRuleNames) {
                    this.configRuleNamesList.map((item) => {
                        this.complianceChecksWarningForm.configRuleNames.push(item.configRuleName)
                    })
                } else {
                    this.complianceChecksWarningForm.configRuleNames = []
                }
            },
            // 切换合规检查
            changeConfigRuleNames: function (val) {
                if (val.length === this.configRuleNamesList.length&&val.length!=0) {
                    this.singleConfigRuleNames = true
                } else {
                    this.singleConfigRuleNames = false
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.complianceChecksWarningForm.ruleName,
                            "monitorIndex": this.complianceChecksWarningForm.monitorIndex,
                            "cycle": this.complianceChecksWarningForm.cycle,
                            "continousCycle": this.complianceChecksWarningForm.continousCycle,
                            "statisticsValue": this.complianceChecksWarningForm.statisticsValue,
                            "relationshipSign": this.complianceChecksWarningForm.relationshipSign,
                            "accountId": this.complianceChecksWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.complianceChecksWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.complianceChecksWarningForm.alarmDelay,
                            "monitorPeriod":this.complianceChecksWarningForm.monitorPeriod,
                            "thresholdValue":this.complianceChecksWarningForm.thresholdValue,
                            "regions":this.complianceChecksWarningForm.backupRegion,
                            "contactType":this.complianceChecksWarningForm.contactType,
                            "configRuleNames":this.complianceChecksWarningForm.configRuleNames,
                            "enterpriseWechatRobotIds":this.complianceChecksWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.complianceChecksWarningForm.contactType == 0){
                            alertList.contactIDs = this.complianceChecksWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.complianceChecksWarningForm.contactType == 1){
                            alertList.contactGroupIds = this.complianceChecksWarningForm.contactGroupIds;
                        }

                        if (this.complianceChecksWarningForm.id > 0) {
                            alertList.id = this.complianceChecksWarningForm.id;
                            // 编辑告警
                            this.addloading=true;
                            tableComplianceChecksWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.complianceChecksWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('编辑成功');
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            tableComplianceChecksWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.complianceChecksWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('添加成功');
                                        this.monitorIndexList=[];
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.complianceChecksWarningForm.id > 0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.complianceChecksWarningForm.notificationObject = [];
                this.monitorIndexList=[];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                this.modal = false;
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/complianceChecks_monitor/AddOrUpdateComplianceChecksWarning.vue